import { Link, Tooltip } from "@mui/material";
import Chip from "@mui/material/Chip";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Typography from "@mui/material/Typography";
import { INVOICE_SUMMARY_PAGE, PO_SUMMARY_PAGE } from "constants/routes";
import PropTypes from "prop-types";
import React from "react";
import { useNavigate } from "react-router";
import { setShowInvoiceSummaryDialogue } from "redux/actions/generalActions";
import { tableHeaderProps } from "styled/props/tableProps";

import CurrencyFigure from "../../displays/currencyFigure";

const convertOU = {
    105: "SSE",
    121: "GEN",
    1256: "IRE",
    203: "RENUK",
    4461: "GENIRE",
    23259: "EGL2",
    23260: "EGL3",
    23983: "DST",
};

const Row = ({ invoice, dispatch, isPoSummary }) => {
    const navigate = useNavigate();
    return (
        <>
            <TableRow hover sx={{ "& > *": { borderBottom: "unset" } }}>
                <TableCell align="center">
                    <Tooltip title={"Click to view Invoice Summary"}>
                        <Link
                            underline="always"
                            component="button"
                            color="secondary"
                            onClick={() => {
                                navigate(
                                    INVOICE_SUMMARY_PAGE(invoice?.INVOICE_ID)
                                );
                                dispatch(setShowInvoiceSummaryDialogue(false));
                            }}
                        >
                            {invoice?.INVOICE_ID}
                        </Link>
                    </Tooltip>
                </TableCell>
                <TableCell align="center">{invoice?.INVOICE_NUM}</TableCell>
                <TableCell align="center">{invoice?.INVOICE_DATE}</TableCell>
                <TableCell align="center">
                    <CurrencyFigure
                        value={
                            invoice?.INVOICE_AMOUNT - invoice?.TOTAL_TAX_AMOUNT
                        }
                        code={invoice?.INVOICE_CURRENCY_CODE}
                    />
                </TableCell>
                <TableCell align="center">
                    {invoice?.INVOICE_TYPE_DISP}
                </TableCell>
                <TableCell align="center">{invoice?.SUPPLIER_NAME}</TableCell>
                <TableCell align="center">
                    {invoice?.SUPPLIER_SITE_CODE}
                </TableCell>
                <TableCell align="center">
                    {invoice?.PAYMENT_STATUS_FLAG == "Y" ? "PAID" : "NOT PAID"}
                </TableCell>
                <TableCell align="center">
                    {invoice?.INVOICE_APPROVAL_STATUS_DISP}
                </TableCell>
                <TableCell align="center">
                    <CurrencyFigure
                        value={invoice?.AMOUNT_DUE}
                        code={invoice?.INVOICE_CURRENCY_CODE}
                    />
                </TableCell>
                {isPoSummary && (
                    <TableCell align="center">
                        {invoice?.ON_HOLD ? "Y" : "N"}
                    </TableCell>
                )}
                {!isPoSummary && (
                    <TableCell align="center">
                        {invoice?.PO_NUMBER ? (
                            <Link
                                underline="always"
                                component="button"
                                color="secondary"
                                onClick={() => {
                                    navigate(
                                        PO_SUMMARY_PAGE(invoice?.PO_NUMBER)
                                    );
                                    dispatch(
                                        setShowInvoiceSummaryDialogue(false)
                                    );
                                }}
                            >
                                <Chip
                                    label={invoice?.PO_NUMBER}
                                    size="small"
                                    sx={{ cursor: "pointer" }}
                                    variant="outlined"
                                    color="info"
                                />
                            </Link>
                        ) : (
                            "N/A"
                        )}
                    </TableCell>
                )}
                <TableCell align="center">
                    <Chip
                        label={convertOU[invoice?.ORG_ID] ?? invoice?.ORG_ID}
                        color="secondary"
                    />
                </TableCell>
            </TableRow>
        </>
    );
};

const InvoiceSearchTable = ({ invoices, dispatch, isPoSummary }) => {
    return (
        <TableContainer>
            <Table size="small">
                <TableHead>
                    <TableRow>
                        <TableCell>
                            <Typography {...tableHeaderProps}>
                                Invoice ID
                            </Typography>
                        </TableCell>
                        <TableCell>
                            <Typography {...tableHeaderProps}>
                                Invoice Number
                            </Typography>
                        </TableCell>
                        <TableCell>
                            <Typography {...tableHeaderProps}>
                                Invoice Date
                            </Typography>
                        </TableCell>
                        <TableCell>
                            <Typography {...tableHeaderProps}>
                                Invoice Net Amount
                            </Typography>
                        </TableCell>
                        <TableCell>
                            <Typography {...tableHeaderProps}>
                                Invoice Type
                            </Typography>
                        </TableCell>
                        <TableCell>
                            <Typography {...tableHeaderProps}>
                                Supplier Name
                            </Typography>
                        </TableCell>
                        <TableCell>
                            <Typography {...tableHeaderProps}>
                                Supplier Site
                            </Typography>
                        </TableCell>
                        <TableCell>
                            <Typography {...tableHeaderProps}>
                                Payment Status
                            </Typography>
                        </TableCell>
                        <TableCell>
                            <Typography {...tableHeaderProps}>
                                Status
                            </Typography>
                        </TableCell>
                        <TableCell>
                            <Typography {...tableHeaderProps}>Due</Typography>
                        </TableCell>
                        {isPoSummary && (
                            <TableCell>
                                <Typography {...tableHeaderProps}>
                                    On Hold
                                </Typography>
                            </TableCell>
                        )}
                        {!isPoSummary && (
                            <TableCell>
                                <Typography {...tableHeaderProps}>
                                    PO Number
                                </Typography>
                            </TableCell>
                        )}
                        <TableCell>
                            <Typography {...tableHeaderProps}>OU</Typography>
                        </TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {invoices.map((invoice) => (
                        <Row
                            isPoSummary={isPoSummary}
                            key={invoice.id}
                            invoice={invoice}
                            dispatch={dispatch}
                        />
                    ))}
                </TableBody>
            </Table>
        </TableContainer>
    );
};

InvoiceSearchTable.propTypes = {
    invoices: PropTypes.array,
    dispatch: PropTypes.func,
    isPoSummary: PropTypes.bool,
};

export default InvoiceSearchTable;
